module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/components/wide-col-basket-item/wide-col-basket-item.component.scss
// module id = ./src/app/modules/boxoffice-module/components/wide-col-basket-item/wide-col-basket-item.component.scss
// module chunks = 9